export default __webpack_public_path__ + "image-divisioncea8b8.png";